import React from 'react';
import ReactDOM from 'react-dom';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import ReduxPromise from 'redux-promise';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// Reducers
import reducerChecklists from './reducers/reducer_lists';
import reducerUser from './reducers/reducer_user';
import reducerView from './reducers/reducer_view';
// Semantic UI
import 'semantic-ui-css/semantic.min.css';

const reducers = combineReducers({
	lists: reducerChecklists,
    user: reducerUser,
    view: reducerView
});

// Add middleware to store
const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);
const store = createStoreWithMiddleware(
	reducers,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);

registerServiceWorker();

// Facebook Messenger SDK
(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/messenger.Extensions.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'Messenger'));

  window.extAsyncInit = function() {
    // the Messenger Extensions JS SDK is done loading
    console.log('the Messenger Extensions JS SDK is done loading');

  };

//   MessengerExtensions.getContext(function success(uids) {
//     // User ID was successfully obtained. 
//         var psid = uids.psid;
//         console.log('psid loaded : ' + psid);

//   }, function error(err, errorMessage) {      
//     // Error handling code
//     console.log('Problem with loading psid.');
//   });    


// WEBPACK FOOTER //
// ./src/index.js